import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

@Injectable()
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {}

  canActivate(): boolean {
    // console.log(this.authenticationService.loggedInUserType,'kkkkkkkkkkkkkkkkkkkkkkkkk')
    if (this.authenticationService.loggedInUserType === 'super-admin-dowc') {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
